import { render, staticRenderFns } from "./CoreTable.vue?vue&type=template&id=548d0b73&scoped=true"
import script from "./CoreTable.vue?vue&type=script&lang=js"
export * from "./CoreTable.vue?vue&type=script&lang=js"
import style0 from "./CoreTable.vue?vue&type=style&index=0&id=548d0b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d0b73",
  null
  
)

export default component.exports